import { useUnsavedForm } from '@/shared/hooks/useUnsavedForm';
import { zodResolver } from '@hookform/resolvers/zod';
import {
    BONUS_OPERATION_FORM_DEFAULTS,
    bonusOperationSchema,
    type BonusOperationFormValues,
} from '@/entities/BonusAccount/model/schema';

/** Создаёт форму бонусной операции */
export const useBonusOperationForm = (enabled = true) => useUnsavedForm<BonusOperationFormValues>({
    resolver: zodResolver(bonusOperationSchema),
    mode: 'onBlur',
    reValidateMode: 'onChange',
    defaultValues: BONUS_OPERATION_FORM_DEFAULTS,
}, enabled);
